

export default {
  name: 'Collection',
  props: {
    collection: {
      type: Array,
      required: true
    }
  },
  computed: {
    findsimilartitle () {
      return this.$t('Find_Similar_Title')
    }
  }
}
